/* eslint-disable no-console */
import { GraphQLError } from 'graphql'
import { ErrorExtensions } from './types'

/**
 * Reports GraphQL errors with detailed information
 * @param error - The GraphQL error to report
 */

export const reportGraphQLError = (
  error: GraphQLError & { extensions: ErrorExtensions }
): void => {
  if (error.message.includes('HELICARRIER ERROR')) {
    const status = error.extensions?.exception?.status
    const errors = error.extensions?.exception?.errors
    console.log(
      '👹 ~ Error: HELICARRIER ERROR',
      error?.extensions?.code,
      status,
      errors?.message
    )
  } else {
    console.error(
      `[GraphQL error]: Message: ${error.message}, Location: ${JSON.stringify(
        error.locations
      )}, Path: ${error.path}`
    )
  }
}

/**
 * Reports Apollo network errors
 * @param networkError - The network error to report
 */
export const reportNetworkError = (networkError: Error): void => {
  console.log(`👹 ~ Error: APOLLO_NETWORK_ERROR`, networkError)
}
